import React, { Component } from "react";
import styled, { keyframes } from "styled-components";
import textToHalfWidth from "../dev/validation/textToHalfWidth";
import CheckIsNumber from '../dev/validation/CheckIsNumber'
import ArrowIcon from "../icon/ArrowIcon";
import { Pagination } from "antd";

class Page extends Component {
    state = {
        pageInputValue: "",
        isPaginationFieldActive: true
    };
    pageInput = e =>
        this.setState({
            pageInputValue: textToHalfWidth(e.target.value),
            isPaginationFieldActive: true
        }); //輸入並轉半形
    pageSubmit = () => {
        const { togglePage, pageCount } = this.props;
        const { pageInputValue } = this.state;
        if (pageInputValue === "") togglePage(1); //若為空白，則跳至第一頁
        if (!CheckIsNumber(pageInputValue))
            return this.setState({ isPaginationFieldActive: false }); //非數字 disable
        if (pageInputValue < 1) return togglePage(1); //輸入小於1的數字時，則到第1頁
        if (pageCount < pageInputValue) return togglePage(pageCount); //輸入大於總頁數的數字時，則到最後一頁
        togglePage(pageInputValue);
    };
    render() {
        const { currentPage, pageCount, togglePage, messages } = this.props;
        const { pageInputValue, isPaginationFieldActive } = this.state;
        const { pageInput, pageSubmit } = this;
        return (
            <Container>
                <Pagination
                    onChange={togglePage}
                    total={pageCount}
                    current={currentPage}
                    defaultPageSize={1}
                />
                <GoToWrap isPaginationFieldActive={isPaginationFieldActive}>
                    <GoToTitle>{messages.jump_to_page}</GoToTitle>
                    <AnimationWrap isPaginationFieldActive={isPaginationFieldActive}>
                        <GoToInput
                            onChange={pageInput}
                            value={pageInputValue}
                            type="text"
                            onKeyPress={e =>
                                e.key === "Enter" &&
                                isPaginationFieldActive &&
                                pageSubmit()
                            }
                        />
                        <GoToSubmit
                            onClick={() =>
                                isPaginationFieldActive && pageSubmit()
                            }
                        >
                            <ArrowIcon color="#fff" />
                        </GoToSubmit>
                    </AnimationWrap>
                </GoToWrap>
            </Container>
        );
    }
}
export default Page;
const shake = keyframes`
    0% {
        transform: translate(6px, 0);
    }
    50% {
        transform: translate(-6px, 0);
    }
    100% {
        transform: translate(0, 0);
    }
`;
const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center
    min-width: 320px;
    margin-top: 32px;
    @media (max-width: 665px){
        flex-direction: column;
    }
    .ant-pagination-item {
        min-width: 24px;
        height: 32px;
        border-radius: 0;
        border-color: #979797;
        a {
            color: #979797;
        }
        @media(max-width: 665px) {
            margin-right: 5px;
        }
        @media(max-width: 350px) {
            margin-right: 3px;
        }
    }
    .ant-pagination-prev, .ant-pagination-next {
        .ant-pagination-item-link {
            border: transparent;
            background-color: transparent;        
        }
        &:hover, &:focus {
            a {
                color: #de0606;
            }
        }
    }
    .ant-pagination-jump-prev, .ant-pagination-jump-next {
        &:hover, &:focus {
            &:after {
                color: #de0606;
            }
        }
    }
    .ant-pagination-item:focus,
    .ant-pagination-item:hover,
    .ant-pagination-item-active {
        -webkit-transition: all .3s;
        transition: all .3s;
        border-color: transparent;
        background-color: #de0606;
        a {
            color: #fff;
        }
    }
`;
const GoToWrap = styled.div`
    display: flex;
    @media (max-width: 665px) {
        justify-content: center;
        width: 100%;
        margin-top: 10px;
    }
`;
const GoToInput = styled.input`
    display: flex;
    width: 2.5rem;
    margin-left: 5px;
    padding-left: 5px;
    border: 0.5px solid #979797;
    border-right: 0;
    border-radius: 0;
    font-size: 16px;
    color: #979797;
    ::-webkit-input-placeholder {
        color: #979797;
        font-weight: 300;
    }
    &:focus {
        outline: none;
    }
`;
const GoToTitle = styled.div`
    display: flex;
    align-items: center;
`;
const GoToSubmit = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 5px;
    cursor: pointer;
    background-color: #979797;
`;
const AnimationWrap = styled.div`
    display: flex;
    ${({ isPaginationFieldActive }) =>
        !isPaginationFieldActive ? `animation: ${shake} 200ms 2 linear` : ""}
`;



// WEBPACK FOOTER //
// ./src/InfoList/Pagination.js